export const FUN_FACTS = {
    BUILD_START_LONG: ({
        tileCount = 'many',
        libraryPhotoCount = 'many',
        libraryName = 'your library',
        remainingTileCount = 'many',
    } = {}) => [
        `We are making a mosaic out of ${tileCount} tiles.`,
        `I am carefully looking at each of the ${libraryPhotoCount} photos from ${libraryName},`,
        'and finding the best one to be the current tile.',
        `And then I shall do the same ${remainingTileCount} times.`,
        "You weren't thinking my job is easy, were you? 🤔",
    ].join('\n'),
    BUILD_START_SHORT: ({
        tileCount = 'many',
        libraryPhotoCount = 'many',
        libraryName = 'your library',
    } = {}) => [
        `We are making a mosaic out of ${tileCount} tiles.`,
        `I am carefully looking at each of the ${libraryPhotoCount} photos from ${libraryName},`,
        'and finding the best one to be the current tile.',
        "It won't take long, I promise! 😏",
    ].join('\n'),
    // You can add more here later, like:
    // HEIC_TIP: "Using an iPhone? We're automatically converting your HEIC photos for you!"
};

export const MESSAGES = {
    JOB_CANCELLED: "Job was successfully cancelled by user."
};
